import { render, staticRenderFns } from "./AssetPropertyView.vue?vue&type=template&id=a9851e96&scoped=true"
import script from "./AssetPropertyView.vue?vue&type=script&lang=js"
export * from "./AssetPropertyView.vue?vue&type=script&lang=js"
import style0 from "./AssetPropertyView.vue?vue&type=style&index=0&id=a9851e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9851e96",
  null
  
)

export default component.exports